import BaseDialog, { customStyles as defaultStyle } from 'components/dialog'
import ButtonBase from 'components/partials/button'
import React from 'react'
import { ClipLoader } from 'react-spinners'

interface Props {
  title: string | string[]
  isOpenDialog: boolean
  handleCloseBtn: () => void
  handleConfirmBtn: () => void
  dialogStyle?: ReactModal.Styles['content']
  isLoading?: boolean
}

const ConfirmDialog: React.FC<Props> = ({
  title,
  isOpenDialog,
  dialogStyle,
  handleCloseBtn,
  handleConfirmBtn,
  isLoading = false,
}) => {
  const customDialogStyle = { content: { ...defaultStyle.content, ...dialogStyle } }
  return (
    <BaseDialog modalIsOpen={isOpenDialog} customStyles={customDialogStyle}>
      <div className="flex flex-col ">
        <div className="flex justify-center pb-5">
          {Array.isArray(title) ? (
            <div className="flex flex-col space-y-2">
              {title.map((item, index) => (
                <p className="text-headline5A text-neutral-1" key={`title-${index}-confirm`}>
                  {item}
                </p>
              ))}
            </div>
          ) : (
            <p className="text-headline5A text-neutral-1">{title}</p>
          )}
        </div>
        <div className="flex flex-col pt-5">
          {isLoading && (
            <div className="flex justify-center">
              <ClipLoader color={'#523280'} size={40} />
            </div>
          )}
          <div className='flex justify-between'>
            <ButtonBase onClick={handleConfirmBtn} disabled={isLoading} bgDisabled="bg-primary-shade3">
              Confirm
            </ButtonBase>
            <ButtonBase onClick={handleCloseBtn} disabled={isLoading} bgDisabled="bg-primary-shade3">Close</ButtonBase>
          </div>
        </div>
      </div>
    </BaseDialog>
  )
}

export default ConfirmDialog
